import jwt_decode from 'jwt-decode';
import { store } from './../app/Slices/store';
import { getAccessToken } from '../app/Slices/AuthSlice';

export default function UserRole(): any {
    const userToken = getAccessToken(store.getState());
    return userToken ? jwt_decode(userToken) : undefined;
}
